import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

export default new Router({
  mode: 'history', // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import('@/views/login/login.vue'),
      meta: { title: '登录', hidden: true }
    },
    {
      path: '/auth',
      component: () => import('@/views/application/index.vue'),
      meta: { title: '应用', hidden: true }
    },
    {
      path: '/404',
      component: () => import('@/views/404.vue'),
      meta: { hidden: true }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/auth'
    },
    {
      path: '/authApp',
      component: Layout,
      redirect: '/authApp/account',
      meta: {
        title: '权限系统',
        icon: 'example'
      },
      children: [
        {
          path: 'account',
          component: () => import('@/views/account/index.vue'),
          meta: {
            title: '账号管理',
            icon: 'account'
          }
        },
        {
          path: 'role',
          component: () => import('@/views/role/index.vue'),
          meta: {
            title: '角色管理',
            icon: 'role'
          }
        },
        {
          path: 'auth',
          component: () => import('@/views/authority/index.vue'),
          meta: {
            title: '权限管理',
            icon: 'auth'
          }
        },
        {
          path: 'menu',
          component: () => import('@/views/menu/index.vue'),
          meta: {
            title: '菜单管理',
            icon: 'menu'
          }
        },
        {
          path: 'api',
          component: () => import('@/views/router/index.vue'),
          meta: {
            title: '路由管理',
            icon: 'api'
          }
        },
        {
          path: 'platform',
          component: () => import('@/views/platform/index.vue'),
          meta: {
            title: '平台管理',
            icon: 'platform'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})
